import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import { OneDriveService } from "@/services/cloud/OneDriveService";
import { CloudConnection } from "@/types/cloud";

export const useOneDriveConnection = () => {
  const queryClient = useQueryClient();

  // Query for connection status
  const {
    data: status,
    isLoading: isLoadingStatus,
    error: statusError,
  } = useQuery<CloudConnection>({
    queryKey: ["onedrive-connection-status"],
    queryFn: () => OneDriveService.getConnectionStatus(),
    staleTime: 1000 * 60 * 5, // 5 minutes
  });

  // Mutation for disconnect
  const disconnectMutation = useMutation({
    mutationFn: () => OneDriveService.disconnect(),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["onedrive-connection-status"] });
      toast.success("OneDrive disconnected");
    },
    onError: (error: any) => {
      toast.error(error.message || "Failed to disconnect OneDrive");
    },
  });

  const connect = () => {
    const oauthUrl = OneDriveService.getOAuthUrl();
    window.location.href = oauthUrl;
  };

  return {
    connected: status?.connected ?? false,
    email: status?.email,
    displayName: status?.displayName,
    connectedAt: status?.connectedAt,
    isLoading: isLoadingStatus,
    error: statusError,
    connect,
    disconnect: () => disconnectMutation.mutate(),
    isDisconnecting: disconnectMutation.isPending,
  };
};
